import { PublicClientApplication } from "@azure/msal-browser";
import { getRedirectURL } from "./Constants.ts";

export const msalConfig = {
  auth: {
    clientId: "d2aad704-5f37-42ec-9c44-f625f87df506",
    authority: "https://login.microsoftonline.com/fd5464de-b3c0-47a0-9cf1-cae2bcf4f544",
    redirectUri: getRedirectURL(),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// Create and initialize the MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle potential errors
msalInstance.initialize()
  .then(() => console.log("MSAL initialized"))
  .catch(error => console.error("MSAL initialization failed", error));